/** Line indices that differ between two pretty-printed JSON strings. */
export function getChangedLineIndices(previous: string, next: string): Set<number> {
  if (previous === next) {
    return new Set();
  }

  const prevLines = previous.split("\n");
  const nextLines = next.split("\n");
  const changed = new Set<number>();
  const lineCount = Math.max(prevLines.length, nextLines.length);

  for (let i = 0; i < lineCount; i++) {
    if (prevLines[i] !== nextLines[i]) {
      changed.add(i);
    }
  }

  return changed;
}
